export default function error404() {
  return (
    <>
      <div className="bg-light">
        <div className="container py-4">
          <div className="bg-white p-4">
            <h1 className="mb-4">404</h1>

            <p>
              Sorry, we can't find the page you are looking for. Let's go to our
              home page to start your sponsorship.
            </p>

            <a href="/" className="btn btn-dark">
              Home
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
